import axios from 'axios';

const instance = axios.create({
    //baseURL: 'https://react-my-burger-cea78.firebaseio.com/'http://smms/API
    //baseURL:'http://smms/API/'
    
    // baseURL:'https://localhost:44338/'
    baseURL:'/API/'
    
    //baseURL:'http://oms.mazaraat.org:81/'
    //baseURL:'https://oms.mazaraat.org:444/'
    //baseURL:'https://oms.mazaraat.org:8443/oms/'

    //http://localhost:3000/Rooms/GetMasterChangeStatusList
    //https://localhost:44338/Rooms/GetMasterChangeStatusList
    //http://localhost:3000/API/Rooms/GetMasterChangeStatusList
});

export default instance;